import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/iconfont/iconfont.css'


Vue.config.productionTip = false
Vue.use(Vant);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
